module.exports = __webpack_public_path__ + "static/assets/cdad5959f5916f1de3a6e086b7756c2c.png";